// extracted by mini-css-extract-plugin
module.exports = {"button":"PromoSecondaryButton_button__KRvjA","button_secondary":"PromoSecondaryButton_button_secondary__9NiO7"};